import { Text } from '@chakra-ui/react';
import React from 'react';
import { TuneCoreRelease } from 'types/releases';
import { ViewOnTuneCoreLink } from 'app/components/Releases/ViewOnTuneCoreLink';

interface TuneCoreExportStatusProps {
  release: TuneCoreRelease;
}

export const TuneCoreExportStatus = ({
  release,
}: TuneCoreExportStatusProps) => {
  const status = release.latestExport?.status;

  if (status === 'PROCESSING') {
    return (
      <Text color="textSubdued" fontWeight={500} fontSize="sm" pt={2}>
        Export in Progress
      </Text>
    );
  }

  if (
    status === 'SUCCESS' ||
    Boolean(
      release.latestExport?.tuneCore?.callbackResponse?.tuneCoreReleaseUrl
    )
  ) {
    return (
      <ViewOnTuneCoreLink release={release} fontWeight={500} fontSize="sm" />
    );
  }

  if (status === 'FAIL') {
    return (
      <Text color="R.80" fontWeight={500} fontSize="sm" pt={2}>
        Export failed. Please retry
      </Text>
    );
  }

  return null;
};
